import * as R from 'ramda'

import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'
import {
  AttributesToResetParticipants,
  ShouldLoadOppositeSubParticipants,
} from '@desktop/views/Relation/Sports/configuration'

export function getLoadOppositeParticipants(
  attributeIds: IncidentAttributeId[] | null,
  shouldLoadOppositeSubParticipants:
    ShouldLoadOppositeSubParticipants | undefined,
): boolean {
  if (!attributeIds) return false
  if (!shouldLoadOppositeSubParticipants) return false

  return typeof shouldLoadOppositeSubParticipants === 'boolean'
    ? shouldLoadOppositeSubParticipants
    : shouldLoadOppositeSubParticipants(attributeIds)
}

/**
 * Participants have to be reset only when one of the
 * `attributesToResetParticipants` is added or removed, because such a change
 * switches the team whose sub-participants are loaded. Keeping an already
 * selected attribute (e.g. own goal) while picking another one must not discard
 * participants.
 */
export function shouldResetParticipants(
  previousAttributeIds: IncidentAttributeId[] | null,
  nextAttributeIds: IncidentAttributeId[],
  attributesToResetParticipants: AttributesToResetParticipants | null,
): boolean {
  if (!attributesToResetParticipants?.length) return false

  const previousResetAttributeIds = (previousAttributeIds ?? []).filter((id) =>
    attributesToResetParticipants.includes(id),
  )
  const nextResetAttributeIds = nextAttributeIds.filter((id) =>
    attributesToResetParticipants.includes(id),
  )

  return (
    R.symmetricDifference(previousResetAttributeIds, nextResetAttributeIds)
      .length > 0
  )
}
